import { ArrowRightLeft, Rocket } from 'lucide-react';

export function MigrationV1V2Page() {
  return (
    <div className="min-h-[80vh] flex flex-col items-center justify-center px-4">
      <div className="text-center max-w-2xl mx-auto">
        <div className="inline-flex items-center justify-center w-20 h-20 rounded-2xl bg-gradient-to-br from-violet-500 to-indigo-600 mb-6 shadow-lg shadow-violet-200 dark:shadow-violet-900/30">
          <ArrowRightLeft className="h-10 w-10 text-white" />
        </div>

        <h1 className="text-3xl font-bold text-gray-900 dark:text-gray-100 mb-3">
          Migration V1 → V2
        </h1>

        <p className="text-lg text-gray-500 dark:text-gray-400 mb-6">
          Un module complet pour migrer vos écoles de l'ancienne infrastructure vers la nouvelle version.
        </p>

        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-violet-100 dark:bg-violet-900/30 border border-violet-300 dark:border-violet-700">
          <Rocket className="h-4 w-4 text-violet-600 dark:text-violet-400" />
          <span className="text-sm font-medium text-violet-700 dark:text-violet-300">
            Bientôt disponible
          </span>
        </div>
      </div>
    </div>
  );
}
